import "./ads.js";
import "./articles.js";

/* const setAdHeight = () => { */
/*   setTimeout(() => { */
/*     var imageL = window.innerWidth >= 900 ? document.querySelector(".ads--large img") : document.querySelector(".ads--large .mobile img"); */
/*     if (imageL != null || imageL != undefined) { */
/*       var imageheight = imageL.clientHeight; */
/*     } */
/*     var imageS = window.innerWidth >= 900 ? document.querySelector(".ads--small img") : document.querySelector(".ads--small .mobile img"); */
/*     if (imageS != null || imageS != undefined) { */
/*       var imageheightS = imageS.clientHeight; */
/*     } */
/*     var ads = document.querySelectorAll(".ads--large") */
/*     if (ads.length >= 1) { */
/*       ads.forEach(ad => { */
/*         ad.style.height = imageheight + 'px'; */
/*       }); */
/*     } */
/*     var adsS = document.querySelectorAll(".ads--small"); */
/*     if (adsS.length >= 1) { */
/*       adsS.forEach(ad => { */
/*         ad.style.height = imageheightS + 'px'; */
/*       }); */
/*     } */
/*   }, 500); */
/* } */
/**/
/* window.setAdHeight = setAdHeight; */

document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth < 900) {
    var galleryimages = document.querySelectorAll('a[data-lightbox="article"]');
    if (galleryimages != undefined || galleryimages != null) {
      galleryimages.forEach((el) => {
        el.removeAttribute("data-lightbox");
      });
    }
  }
  /* setAdHeight(); */

  /* window.addEventListener("resize", function() { */
  /*   setAdHeight(); */
  /* }); */

  document.body.style.marginTop = "1px";
  document.body.style.marginTop = "0px;";
  var lightbox = new SimpleLightbox(".article-gallery-item a", {
    captionSelector: "self",
    captionType: "data",
    captionPosition: "bottom",
    animationSpeed: 250,
  });
  document.querySelector("#open-nav").addEventListener("click", function (e) {
    e.preventDefault();
    document.querySelector("#nav").style.display = "block";
    document.querySelector(".logo-container").style.display = "none";
    document.body.style.overflow = "hidden";
  });
  document.querySelector("#close-nav").addEventListener("click", function (e) {
    e.preventDefault();
    document.querySelector("#nav").style.display = "none";
    document.querySelector(".logo-container").style.display = "block";
    document.body.style.overflow = "auto";
  });
  document
    .querySelector("#open-search")
    .addEventListener("click", function (e) {
      e.preventDefault();
      document.querySelector("#search").style.display = "block";
      document.querySelector(".logo-container").style.display = "none";
      document.body.style.overflow = "hidden";
    });
  var bannerSearch = document.querySelector("#banner-search");
  if (bannerSearch != undefined || bannerSearch != null) {
    bannerSearch.addEventListener("click", function (e) {
      e.preventDefault();
      document.querySelector("#search").style.display = "block";
      document.querySelector(".logo-container").style.display = "none";
      document.body.style.overflow = "hidden";
    });
  }

  document
    .querySelector("#close-search")
    .addEventListener("click", function (e) {
      e.preventDefault();
      document.querySelector("#search").style.display = "none";
      document.querySelector("#search-results").style.display = "none";
      document.querySelector(".logo-container").style.display = "block";

      document.body.style.overflow = "auto";
      var location = window.location.href.split("?")[0];
      history.pushState(null, null, location);
    });
  if (window.location.href.indexOf("?q") >= 1) {
    document.querySelector("#search").style.display = "block";
    document.querySelector("#search-results").style.display = "block";
    document.body.style.overflow = "hidden";
  }
  var letterLists = document.querySelectorAll(".letter-list");
  if (letterLists.length > 0) {
    for (let i = 0; i < letterLists.length; i++) {
      if (letterLists[i].getElementsByTagName("li").length < 2) {
        letterLists[i].style.display = "none";
      }
    }
  }

  var searchCategories = document.querySelectorAll(".search.category");
  if (searchCategories.length > 0) {
    for (let i = 0; i < searchCategories.length; i++) {
      searchCategories[i].addEventListener("click", function () {
        searchCategories[i].classList.toggle("active");
        var searchinput = document.querySelector("#tag-input");
        if (searchinput.value.indexOf(this.getAttribute("data-tag")) !== -1) {
          searchinput.value = searchinput.value.replace(
            this.getAttribute("data-tag"),
            ""
          );
        } else {
          if (searchinput.value == "") {
            searchinput.value = this.getAttribute("data-tag");
          } else {
            searchinput.value =
              searchinput.value + " " + this.getAttribute("data-tag");
          }
        }

        searchinput.value = searchinput.value.trim();

        var useHoverEffect = false;
        for (let y = 0; y < searchCategories.length; y++) {
          if (searchCategories[y].classList.contains("active")) {
            useHoverEffect = true;
          }
        }
        if (useHoverEffect) {
          document.querySelector("#show-search-result").classList.add("active");
        } else {
          document
            .querySelector("#show-search-result")
            .classList.remove("active");
        }
      });
    }
  }

  var searchYears = document.querySelectorAll(".search.year");

  if (searchYears.length > 0) {
    for (let i = 0; i < searchYears.length; i++) {
      searchYears[i].addEventListener("click", function () {
        searchYears[i].classList.toggle("active");
        var searchinput = document.querySelector("#year-input");
        if (searchinput.value.indexOf(this.innerText) !== -1) {
          searchinput.value = searchinput.value.replace(this.innerText, "");
        } else {
          if (searchinput.value == "") {
            searchinput.value = this.innerText;
          } else {
            searchinput.value = searchinput.value + " " + this.innerText;
          }
        }

        searchinput.value = searchinput.value.trim();
      });
    }
  }

  var showSearchResult = document.querySelector("#show-search-result");
  if (showSearchResult != undefined || showSearchResult != null) {
    showSearchResult.addEventListener("click", function (e) {
      e.preventDefault();
      document.querySelector("#search-form").submit();
    });
  }
  var backToSearch = document.querySelector("#back-to-search");
  if (backToSearch != undefined || backToSearch != null) {
    backToSearch.addEventListener("click", function () {
      document.querySelector("#search").style.display = "block";
      document.querySelector("#search-results").style.display = "none";
      var location = window.location.href.split("?")[0];
      history.pushState(null, null, location);
    });
  }

  var searchinput = document.querySelector("#search-input");
  if (searchinput != null || searchinput != undefined) {
    if (window.innerWidth < 900) {
      searchinput.placeholder = "Søk i innhold";
    }
  }
  var tags = document.querySelectorAll(".tag");
  for (let i = 0; i < tags.length; i++) {
    tags[i].addEventListener("click", function (e) {
      e.preventDefault();
      window.location.href = "/?q=&tag=" + this.getAttribute("data-tag");
    });
  }

  var didScroll;
  var lastScrollTop = 0;
  var delta = 5;

  function didScroll() {
    didScroll = true;
  }

  setInterval(function () {
    if (didScroll) {
      hideShowToTop();
      didScroll = false;
    }
  }, 250);

  function hideShowToTop() {
    var toTop = document.querySelector("#scroll-to-top");
    if (window.pageYOffset > 2 * window.innerHeight) {
      toTop.style.display = "block";
    } else {
      toTop.style.display = "none";
    }

    if (window.innerWidth < 900) {
      var currentScrollPos = window.pageYOffset;
      document.querySelector("header").style.transition = "all 0.2s";

      if (Math.abs(lastScrollTop - currentScrollPos) <= delta) {
        return;
      }
      if (currentScrollPos > lastScrollTop && currentScrollPos > 75) {
        document.querySelector("header").style.transform = "translateY(-75px)";
      } else {
        if (
          currentScrollPos + window.innerHeight <
          document.body.clientHeight
        ) {
          document.querySelector("header").style.transform = "translateY(0)";
        }
      }
      lastScrollTop = currentScrollPos;
    }
  }
  //hideShowToTop();
  window.onscroll = didScroll;

  function changeBannerSearchWidth() {
    var bannerSearch = document.querySelector("#banner-search");
    var article = document.querySelector(
      ".article-section.three-article-section .article-container .article:nth-child(3n+2)"
    );
    if (bannerSearch != undefined || bannerSearch != null) {
      if (article != undefined || article != null) {
        var bannerRightPos =
          bannerSearch.offsetWidth + bannerSearch.offsetLeft + 14;
        var articleRightPos = article.offsetWidth + article.offsetLeft;
        bannerSearch.style.minWidth =
          bannerSearch.offsetWidth + (articleRightPos - bannerRightPos) + "px";
        bannerSearch.style.maxWidth =
          bannerSearch.offsetWidth + (articleRightPos - bannerRightPos) + "px";
      }
    }
  }
  changeBannerSearchWidth();
  window.onresize = changeBannerSearchWidth;

  var articleText = document.querySelector(".article-content .text-container");
  //console.log(articleText.clientHeight);
  if (articleText != null || articleText != undefined) {
    if (articleText.clientHeight > 800) {
      var node = document.createElement("a");
      var text = document.createTextNode("Les videre");
      node.appendChild(text);
      node.addEventListener("click", function (e) {
        articleText.classList.remove("fade-out");
        node.style.display = "none";
      });
      node.classList.add("article-read-more");
      //console.log(node);
      articleText.parentElement.appendChild(node);
      articleText.classList.add("fade-out");
    }
  }
});
